import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "URL", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "float-start w-auto pe-1" }, "Enter a Twitter URL for a tweet, profile or list.", -1)
const _hoisted_4 = {
  key: 0,
  class: "error mb-0"
}
const _hoisted_5 = { class: "row d-flex" }
const _hoisted_6 = { class: "row d-flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Background", -1)
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Other", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Refresh Interval"),
  /*#__PURE__*/_createElementVNode("p", null, "Ditto refreshes the source every 10 minutes to ensure data is current.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData,
    disabled: _ctx.layoutDisbabled
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_el_form_item, { prop: "url" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              class: _normalizeClass({'url-invalid' : (!_ctx.isUrlValid),  'url-valid' : (_ctx.isUrlValid) }),
              modelValue: _ctx.signageItemLayoutData.url,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.url) = $event)),
              placeholder: "url",
              "suffix-icon": {'el-icon-warning url-invalid':(!_ctx.isUrlValid), 'el-icon-check url-valid':(_ctx.isUrlValid)}
            }, null, 8, ["class", "modelValue", "suffix-icon"]),
            (!_ctx.isUrlValid)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Invalid URL"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "headline",
          label: "Headline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.headline,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.headline) = $event)),
              placeholder: "Headline text"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_form_item, { label: "Use Background Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.signageItemLayoutData.useBackgroundMedia,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.useBackgroundMedia) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useBackgroundMedia)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Background Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "false",
                  sizeLimitMB: "300",
                  layoutProperty: "asset1",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "backgroundColor",
            label: "Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                disabled: _ctx.signageItemLayoutData.useBackgroundMedia,
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.backgroundColor,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "fontColor",
            label: "Headline Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.headlineColor,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.headlineColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_el_form_item, { label: "Dark Mode" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.signageItemLayoutData.darkMode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.darkMode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.isTweet)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Show Conversation"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.signageItemLayoutData.showConversation,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageItemLayoutData.showConversation) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _hoisted_11
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}